<template>
  <div class="max-w-7xl mx-auto mb-5">
    <div class="pointer-events-auto overflow-hidden rounded-lg bg-indigo-600 shadow-lg ring-1 ring-black ring-opacity-5 mb-4 w-full">
      <div class="p-4">
        <div class="flex flex-col lg:flex-row lg:items-center gap-3">
          <div class="flex items-start flex-1 min-w-0">
            <div class="flex-shrink-0">
              <SparklesIcon class="w-5 h-5 text-gray-100" />
            </div>
            <div class="ml-2 min-w-0">
              <p class="text-sm font-bold text-white">Exclusive Invitation:</p>
              <p class="text-sm text-indigo-100">
                Get private early access to the new Skilltech platform. Expires in
                <span class="font-bold text-white bg-black bg-opacity-25 rounded px-1.5 py-0.5">{{ countdownLabel }}</span>
              </p>
            </div>
          </div>
          <div class="flex lg:flex-shrink-0 lg:justify-end">
            <button
              type="button"
              @click="$emit('view')"
              class="w-full lg:w-auto whitespace-nowrap rounded-md bg-white px-4 py-2 text-sm font-semibold text-indigo-700 shadow-sm hover:bg-indigo-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-indigo-600 focus:ring-white"
            >
              View Invitation
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SparklesIcon } from "@heroicons/vue/outline";
import { invitationService } from "@/utils/invitation";

export default {
  components: { SparklesIcon },
  props: {
    expiresAt: { type: Number, default: null },
  },
  emits: ["view", "expired"],
  data() {
    return {
      countdown: { hours: 0, minutes: 0, seconds: 0, expired: false },
      tickInterval: null,
    };
  },
  computed: {
    countdownLabel() {
      const pad = (n) => String(n).padStart(2, "0");
      return `${pad(this.countdown.hours)}:${pad(this.countdown.minutes)}:${pad(this.countdown.seconds)}`;
    },
  },
  methods: {
    tick() {
      this.countdown = invitationService.getCountdownParts(this.expiresAt);
      if (this.countdown.expired) {
        this.$emit("expired");
        this.stopTicking();
      }
    },
    stopTicking() {
      if (this.tickInterval) {
        clearInterval(this.tickInterval);
        this.tickInterval = null;
      }
    },
  },
  created() {
    this.tick();
    this.tickInterval = setInterval(this.tick, 1000);
  },
  beforeUnmount() {
    this.stopTicking();
  },
};
</script>
